export class GetCategories {
    async getCategories() {
        const apiUrl = process.env.REACT_APP_API_URL;
        const url = new URL(`/categories`, apiUrl);
        const response = await fetch(url.toString());
        const data = await response.json();
        return data;
    }
}
